import { GetOfferQuery } from 'generated/graphql';

type OfferPricing = {
  price: number | null;
  checkoutUrl: string | null;
};

export const toOfferPricing = (data: GetOfferQuery): OfferPricing => {
  const price = data.bundleById?.oneTimeProduct?.price ?? null;
  const checkoutUrl = data.bundleById?.checkoutPage?.url ?? null;

  return {
    price,
    checkoutUrl,
  };
};
